import { api } from 'services/axios'

export interface IAuthNationalResponse {
    phone_number: string
    national_code: string
    kyc_status: string
}

export const authNational = async (nationalCode: string) => {
    const { data }: { data: IAuthNationalResponse } = await api.get(
        '/account/update_kyc/'
    )
    return data
}

export const updateNationalCode = async (nationalCode: string) => {
    const { data }: { data: IAuthNationalResponse } = await api.post(
        '/account/update_kyc/',
        {
            national_code: nationalCode,
        }
    )
    return data
}
